<template>
    <div id="page-wrapper">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            {{$t('profile.title')}}
            <a class="btn-settings" href=""><i class="fa fa-cog"></i></a>
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="col-lg-4 col-xl-4 col-xxl-3">
          <div class="panel panel-default">
            <div class="panel-heading text-center">
              <div class="profile-img" v-bind:style="{ 'background-image': 'url(/static/assets/images/avatars/' + avatar + ')' }"></div>
              <button type="button" class="btn btn-xs btn-primary mrg-b-20" v-show="!showChangeAvatar" v-on:click="showChangeAvatar = true">{{$t('shared.buttons.change')}}</button>
              <div v-if="showChangeAvatar">
                <carousel :nav="false" :items="4">
                  <img v-for="v in avatars" :src="'/static/assets/images/avatars/' + v" v-on:click="changeAvatar(v)">
                </carousel>
                <spin-button id="btnSaveAvatar" :css-class="'btn btn-xs btn-primary mrg-b-20'" :button-text="$t('shared.buttons.save')" :loading="spinners.savingAvatar" :loading-text="$t('shared.buttons.saving')" :onClick="saveAvatar"></spin-button>
                <button type="button" class="btn btn-xs btn-primary mrg-b-20" v-on:click="showChangeAvatar = false">{{$t('shared.buttons.cancel')}}</button>
              </div>
              <h2>{{user.fullName}}</h2>
              <h4 class="mrg-b-40">{{user.email}}</h4>
            </div>
            <div class="panel-footer">
              <total-balance></total-balance>
            </div>
            <div class="panel-body-nav">
              <ul class="nav">
                <li>
                  <a href="/client/profile"><i class="far fa-user-circle"></i> {{$t('profile.title')}}</a>
                </li>
                <li>
                  <a href="#updateprofile" v-on:click="selectTab('updateprofile')"><i class="fas fa-code-branch"></i> {{$t('profile.update_profile')}} </a>
                </li>
                <li>
                  <a href="#documents" v-on:click="selectTab('documents')"><i class="far fa-comments"></i> {{$t('profile.documents')}} </a>
                </li>
                <li>
                  <a href="#changepassword" v-on:click="selectTab('changepassword')"><i class="fa fa-user-shield"></i> {{$t('profile.change_password')}} </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-xl-8 col-xxl-9">
          <div class="panel panel-default">
            <div class="panel-heading clearfix">
              <ul class="nav nav-tabs pull-left">
                <li class="active">
                  <a id="updateprofileHref" href="#updateprofile" data-toggle="tab">{{$t('profile.update_profile')}}</a>
                </li>
                <li>
                  <a id="documentsHref" href="#documents" data-toggle="tab">{{$t('profile.documents')}}</a>
                </li>
                <li>
                  <a id="changepasswordHref" href="#changepassword" data-toggle="tab">{{$t('profile.change_password')}}</a>
                </li>
              </ul>

              <div class="pull-right">
                <div class="btn-group">
                  <a href="#" class="panel-menu" data-toggle="dropdown">
                    <i class="fa fa-ellipsis-h"></i>
                  </a>
                  <ul class="dropdown-menu pull-right" role="menu">
                    <li>
                      <a href="#" v-on:click="selectTab('updateprofile')">{{$t('profile.update_profile')}}</a>
                    </li>
                    <li>
                      <a href="#" v-on:click="selectTab('documents')">{{$t('profile.documents')}}</a>
                    </li>
                    <li>
                      <a href="#" v-on:click="selectTab('changepassword')">{{$t('profile.change_password')}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="updateprofile">
                  <form>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9 col-md-9">
                        <h3>1. {{$t('profile.personal_details')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="firstName" class="label-horizontal">{{$t('profile.first_name')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="firstName" v-model="user.firstName" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="lastName" class="label-horizontal">{{$t('profile.last_name')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="lastName" v-model="user.lastName" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="phoneNo" class="label-horizontal">{{$t('profile.phone')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="phoneNo" v-model="user.phone" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="idNo" class="label-horizontal">{{$t('profile.id_number')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="idNo" v-model="user.identityCard" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="dateOfBirth" class="label-horizontal">{{$t('profile.date_of_birth')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <date-picker v-model="user.dateOfBirth" format="DD-MM-YYYY" :not-after="new Date().setFullYear(new Date().getFullYear() - 18)" lang="es" input-class="form-control"></date-picker>
                      </div>
                    </div>

                    <!--ADDRESS-->
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">
                        <h3>2. {{$t('profile.address')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="" class="label-horizontal">{{$t('profile.street')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="address" v-model="user.street" />
                        <p>Calle, Número, Piso, etc..</p>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="city" class="label-horizontal">{{$t('profile.city')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="city" v-model="user.city" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="state" class="label-horizontal">{{$t('profile.state')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" class="form-control" id="state" v-model="user.state" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="postalcode" class="label-horizontal">{{$t('profile.postcode')}}</label>
                      </div>
                      <div class="col-sm-4 col-md-5">
                        <input type="text" class="form-control" id="postalcode" v-model="user.postcode" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="country" class="label-horizontal">{{$t('profile.country')}}</label>
                      </div>
                      <div class="col-sm-4 col-md-5">
                        <select v-model="user.country" class="form-control" id="country" name="country">
                          <option v-for="v in countryList" :value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>
                    <!--MORE INFO-->
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">
                        <h3>3. {{$t('profile.more_information')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="tradingFrequency" class="label-horizontal">{{$t('profile.trading_frequency')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <select v-model="user.tradingFrecuencyType" class="form-control" id="tradingFrequency" name="tradingFrequency">
                          <option v-for="v in tradingFrequencyList" v-bind:value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="financialInstruments" class="label-horizontal">{{$t('profile.financial_instruments')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <select v-model="user.financialIntrumentType" class="form-control" id="financialInstruments" name="financialInstruments">
                          <option v-for="v in financialInstrumentsList" :value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="experience" class="label-horizontal">{{$t('profile.experience')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <select v-model="user.experienceType" class="form-control" id="experience" name="experience">
                          <option v-for="v in experienceList" :value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="riskTolerance" class="label-horizontal">{{$t('profile.risk_tolerance')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <select v-model="user.riskToleranceType" class="form-control" id="riskToleranceType" name="riskTolerance">
                          <option v-for="v in riskToleranceList" :value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="education" class="label-horizontal">{{$t('profile.education')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <select v-model="user.educationType" class="form-control" id="education" name="education">
                          <option v-for="v in educationList" :value="v">{{v.text}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">

                        <button type="button" v-on:click="save()" class="btn btn-primary mrg-r-15 mrg-b-25 v-button" :disabled="spinners.savingProfile"><i v-if="spinners.savingProfile" class='fa fa-spinner fa-spin v-button'></i><span v-if="spinners.savingProfile">{{$t('shared.buttons.saving')}}</span><span v-if="!spinners.savingProfile">{{$t('shared.buttons.save_changes')}}</span></button>
                        <button type="button" class="btn btn-default mrg-b-25">{{$t('shared.buttons.cancel')}}</button>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="tab-pane fade" id="documents">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="upload-btn-wrapper">
                          <button type="submit" class="btn btn-xs btn-primary mrg-b-20">{{$t('shared.buttons.upload_file')}}</button>
                          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Date Entered</th>
                              <th scope="col">Name</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr  v-for="(d, index) in documents">
                              <th scope="row">{{index + 1}}</th>
                              <td>{{d.dateEntered | formatDate}}</td>
                              <td>{{d.fileName}}</td>
                              <td><a :href="d.downloadUrl"><i class="fas fa-download align"></i></a> </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="changepassword">
                  <h4>{{$t('profile.change_password')}}</h4>
                  <div class="tab-pane fade in active">
                    <form>
                      <div class="form-group row">
                        <div class="col-sm-7 col-md-6">
                          <div id="pswd_info">
                            <ul id="requirements">
                              <li id="letter" class="invalid">{{$t('profile.password_validators.letter')}}</li>
                              <li id="capital" class="invalid">{{$t('profile.password_validators.capital')}}</li>
                              <li id="number" class="invalid">{{$t('profile.password_validators.number')}}</li>
                              <li id="length" class="invalid">{{$t('profile.password_validators.length')}}</li>
                              <li id="special" class="invalid">{{$t('profile.password_validators.special')}}</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-4">
                          <input type="password" class="form-control form-control-contra" id="password" v-model="password" maxlength="10" />
                          <br />
                         <spin-button id="btnChangePassword" :button-text="$t('profile.change_password_now')" :loading="spinners.changePassword" :loading-text="$t('shared.buttons.updating_data')" :onClick="changePassword"></spin-button>
                        </div>
                      </div>
                    </form>
                  </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
 
</template>

<script>

  import ProfileService from '@/services/ProfileService';
  import SecurityService from '@/services/SecurityService';
  import { getSummary } from '@/services/MT4Service'
  import AuthService from '@/services/AuthService'
  import EventBus from '@/event-bus';
  import swal from 'sweetalert2';


  let srv = new ProfileService();
  let secSrv = new SecurityService();

  export default {
    data() {
      return {
        spinners: {
          savingProfile : false,
          savingAvatar: false,
          changePassword: false
        },
        avatar: '',
        showChangeAvatar: false,
        avatars: ['01.png','02.png','03.png','04.png','05.png','06.png','07.png','08.png','09.png','10.png','11.png','12.png','13.png'],
        user: {},
        selectedTab: '',
        totalFunds: 0,
        tradingFrequencyList: [],
        financialInstrumentsList: [],
        experienceList: [],
        riskToleranceList: [],
        educationList: [],
        countryList: [],
        file: null,
        documents: [],
        password: '',
        defaultMT4Account: 0,
      };
    },
    created() {
      let t = this;
      srv.get().then(u => {
        return u;
      }).then(r => {
        t.user = r.data;
        t.avatar = r.data.avatarUrl;

      });

      srv.getTradingFrequencyList().then(r => {
        this.tradingFrequencyList = r.data;
      });

      srv.getFinancialInstrumentsList().then(r => {
        this.financialInstrumentsList = r.data;
      });

      srv.getExperienceList().then(r => {
        this.experienceList = r.data;
      });

      srv.getRiskToleranceList().then(r => {
        this.riskToleranceList = r.data;
      });

      srv.getEducationList().then(r => {
        this.educationList = r.data;
      });

      srv.getCountryList().then(r => {
        this.countryList = r.data;
      });

      srv.getDocuments().then(r => {
        this.documents = r.data;
      });
    },
    computed: {
      href() {
        let windowLocationHash = window.location.hash;
        return windowLocationHash;
      }
    },
    methods: {
      selectTab(tab) {
        if (tab) {
          let o = document.getElementById(tab + 'Href');
          if (o) {
            o.click();
          }
        }
      },

      save() {
        this.spinners.savingProfile = true
        srv.save(this.user).then(r => {
          swal({
            position: 'top-end',
            type: 'success',
            title: this.$t('profile.messages.save_ok'),
            showConfirmButton: false,
            timer: 1500
          });
          this.spinners.savingProfile = false
        }).catch(e => {
         this.spinners.savingProfile = false;
          swal({
            position: 'top-end',
            type: 'error',
            title: e.response.data,
            showConfirmButton: false,
            timer: 2000
          });
        });
      },
      changeAvatar(v){
        this.avatar = v;
      },
      saveAvatar(){
        this.spinners.savingAvatar = true;
        srv.updateAvatar(this.avatar).then(r => {
          let u = AuthService.getUser();
          u.avatarUrl = this.avatar;
          AuthService.setUser(u);
          EventBus.$emit('profileUpdated');
          this.showChangeAvatar = false;
        }).finally(()=>{
          this.spinners.savingAvatar = false;
        });
      },
      handleFileUpload() {
        let v = this;
        v.file = v.$refs.file.files[0];

        let formData = new FormData();
        formData.append('file', v.file);

        srv.addDocument(formData).then((r) => {
          v.documents.push(r.data);
        }).catch((e) => {
          console.log(e);
        });
      },
      changePassword() {
        this.spinners.changePassword = true;
        secSrv.changePassword(this.password).then((r) => {
          swal({
            position: 'top-end',
            type: 'success',
            title: this.$t('profile.messages.change_password_ok'),
            showConfirmButton: false,
            timer: 1500
          });
          this.spinners.changePassword = false;
          this.password = null;
        }).catch(e => {
         this.spinners.changePassword = false;
          swal({
            position: 'top-end',
            type: 'error',
            title: e.response.data,
            showConfirmButton: false,
            timer: 2000
          });
        });
      }
    },
    mounted() {
      let tab = this.href.replace('#', '');
      this.selectTab(tab);
    }
  };

  $(document).ready(() => {

    $('#special').removeClass('invalid').addClass('valid');
    $('#btnChangePassword').prop('disabled', true);
    $('input[type=password]').keyup(function () {

      var pswd = $(this).val();
      var isValidLength = false;
      var isValidLetter = false;
      var isValidCapital = false;
      var isValidNumber = false;
      var isValidNoSpecialChars = true;

      if (pswd.length < 8 || pswd.length > 10) {
        $('#length').removeClass('valid').addClass('invalid');
        isValidLength = false;
      } else {
        $('#length').removeClass('invalid').addClass('valid');
        isValidLength = true;
      }

      if (pswd.match(/[A-z]/)) {
        $('#letter').removeClass('invalid').addClass('valid');
        isValidLetter = true;
      } else {
        $('#letter').removeClass('valid').addClass('invalid');
        isValidLetter = false;

      }

      if (pswd.match(/[A-Z]/)) {
        $('#capital').removeClass('invalid').addClass('valid');
        isValidCapital = true;
      } else {
        $('#capital').removeClass('valid').addClass('invalid');
        isValidCapital = false;

      }

      //validate number
      if (pswd.match(/\d/)) {
        $('#number').removeClass('invalid').addClass('valid');
        isValidNumber = true;
      } else {
        $('#number').removeClass('valid').addClass('invalid');
        isValidNumber = false;

      }

      if (pswd.length > 0) {
        //special chars
        if (pswd.match(/^[a-zA-Z0-9]+$/)) {
          $('#special').removeClass('invalid').addClass('valid');
          var isValidNoSpecialChars = true;
        } else {
          $('#special').removeClass('valid').addClass('invalid');
          var isValidNoSpecialChars = false;

        }
      }

      function validatePassword() {
        if (isValidLength && isValidLetter && isValidCapital && isValidNumber && isValidNoSpecialChars) {
          $('#btnChangePassword').prop('disabled', false);
        } else {
          $('#btnChangePassword').prop('disabled', true);
        }
      }

      validatePassword();

    }).focus(function () {
      //  $('#pswd_info').show();
    }).blur(function () {
      // $('#pswd_info').hide();
    });

  });
</script>




// WEBPACK FOOTER //
// src/components/views/Profile.vue